import { useQueryClient } from '@tanstack/react-query';
import { Button, Form, Modal } from 'antd';
import { useContext } from 'react';

import { ViewEditModeContext } from 'app/context/ViewEditModeContext/ViewEditModeContext';
import { path } from 'app/hooks/data/adminBookingDetails/useAdminBooking';
import { useCancelBooking } from 'app/hooks/data/core/admin/bookings/useCancelBooking';
import type { CancelBookingRequest } from 'app/typings/core/admin/bookings/bookingForm';

import { CancellationFormFields } from './CancellationFormFields';
import styles from './Modals.module.scss';

type Props = {
  isModalOpen: boolean;
  setIsModalOpen: (bool: boolean) => void;
  code: string;
};

export const CancelModal = ({ isModalOpen, setIsModalOpen, code }: Props) => {
  const [form] = Form.useForm();
  const { enterViewMode } = useContext(ViewEditModeContext);

  const { mutateAsync: cancelBooking } = useCancelBooking();
  const queryClient = useQueryClient();

  const handleOk = async (values: CancelBookingRequest) => {
    await cancelBooking({ code, payload: values });
    queryClient.invalidateQueries({ queryKey: [path, { bookingCode: code }] });
    onCancel();
  };

  const onCancel = () => {
    setIsModalOpen(false);
    form.resetFields();
    enterViewMode();
  };

  return (
    <Modal
      title="Cancel booking"
      open={isModalOpen}
      width={572}
      closable
      destroyOnClose
      onCancel={onCancel}
      centered
      className={styles.bookingCancelModal}
      footer={[
        <Button key="confirm" onClick={form.submit} type="primary">
          Confirm
        </Button>,
      ]}
    >
      <Form
        className={styles.cancelBookingForm}
        onFinish={handleOk}
        form={form}
        layout="vertical"
      >
        <CancellationFormFields />
      </Form>
    </Modal>
  );
};
